import React, { Component } from "react";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import resumeData from "./resumeData.json";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resumeData,
    };
  }

  render() {
    return (
      <main className="portfolio-page">
        <Header data={this.state.resumeData.main} />
        <About data={this.state.resumeData.main} />
        <Resume data={this.state.resumeData.resume} />
        <Contact data={this.state.resumeData.main} />
        <Footer data={this.state.resumeData.main} />
      </main>
    );
  }
}

export default App;